import smoothscroll from 'smoothscroll-polyfill';
import { viewportUnits } from './functions/utilities'
import { initHeader, headerHeight } from './functions/header'
import { initProductSlider, initCardSlider, initImageSlider } from './functions/sliders'
import { initModal } from './functions/modal'
import { initContactForm } from './functions/form'
import { linkHandler } from './functions/link'
import { initTable } from './functions/table'

smoothscroll.polyfill()

document.addEventListener('DOMContentLoaded', () => {
  viewportUnits()
  initHeader()
  headerHeight()
  initProductSlider()
  initCardSlider()
  initImageSlider()
  initModal()
  initContactForm()
  linkHandler()
  initTable()
})
